/* eslint-disable no-use-before-define */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/naming-convention */
import { IUiAffordabilityModel } from '../../models/affordability-ui';
import { CustomerDetailsReportRequestModel } from '../../models/lghf-email';
import { format } from 'date-fns-tz';
import { EmploymentStatus, PropertyType } from '../../models';


export function toEmailRequest(
  model: IUiAffordabilityModel,
  customers: any[],
  results: any,
  affiliateCID: string,
  trafficSource: string,
) : CustomerDetailsReportRequestModel {
  return {
    affiliateCID,
    trafficSource,
    isD2C: customers?.length ? true : false,
    customers,
    propertyDetails: {
      mortgageType: model.propertyAndLoan.mortgageType,
      propertyType: mapPropertyType(model.propertyAndLoan.propertyType),
      propertyValue: model.propertyAndLoan.propertyValue,
      loanAmount: model.propertyAndLoan.loanAmount,
      gap: model.propertyAndLoan.gap ?? false,
    },
    applicants: model.incomeAndExpenditure.applicants.map((app) => {
      return {
        dependantsAged18AndOver: model.applicants.dependantsAged18AndOver ?? 0,
        dependantsAged12To17: model.applicants.dependantsAged12To17 ?? 0,
        dependantsAged6To11: model.applicants.dependantsAged6To11 ?? 0,
        dependantsAged0To5: model.applicants.dependantsAged0To5 ?? 0,
        dateOfBirth: format(new Date(app.dateOfBirth.year, app.dateOfBirth.month - 1, app.dateOfBirth.day),
          'yyyy/MM/dd HH:mm', { timeZone: 'Europe/London' }),
        primaryIncome: {
          employmentStatus: mapEmploymentStatus(app.primaryIncome.employmentStatus),
          expectedRetirementAge: app.primaryIncome.plannedRetirementAge ?? 0,
          annualGrossTotalIncome: app.primaryIncome.grossAnnualIncome ?? 0,
          annualBonusCommissionOvertime: app.primaryIncome.annualBonusCommissionOvertime ?? 0,
          businessEarningsForLastFullYear: app.primaryIncome.netProfitForLatestPeriod ?? 0,
          businessEarningsForPreviousFullYear: app.primaryIncome.netProfitForPreviousPeriod ?? 0,
          dividendsPlusSalaryForMostRecentAccountingPeriod: app.primaryIncome.grossRemunerationForLatestPeriod ?? 0,
          dividendsPlusSalaryForPreviousAccountingPeriod: app.primaryIncome.grossRemunerationForPreviousPeriod ?? 0,
        },
        otherIncome: {
          AnnualBuyToLetIncome: app.btlInvestmentIncome ?? 0,
          AnnualBuyToLetIncomeDependantPercent: app.btlInvestmentIncomeBenefit ?? 0,
          AnnualIncomePaymentsInvestment: app.nonGuaranteedInvestmentIncome ?? 0,
          AnnualIncomePaymentsInvestmentDependantPercent: app.nonGuaranteedInvestmentIncomeDependent ?? 0,
          GrowthInvestmentAnnualIncome: app.growthInvestmentAnnualIncome ?? 0,
          GrowthInvestmentAnnualIncomeDependantPercent: app.growthInvestmentAnnualIncomeDependents ?? 0,
          DisabilityBenefit: app.disabilityBenefit ?? 0,
          AnnualAdditionalIncome: app.annualAdditionalIncome ?? 0,
        },
        currentRetirementIncome: {
          annualStatePension: app.annualStatePension ?? 0,
          currentDrawdownPensionFund: app.definedContribution,
          annualNonEscalatingAnnuity: app.annualNonEscalatingAnnuity,
          annualEscalatingAnnuity: app.annualEscalatingAnnuity,
          annualDefinedBenefitFinalSalaryPension: app.definedBenefitFinalSalaryPension,
        },
        futureRetirementIncome: {
          expectedAnnualStatePension: app.expectedAnnualStatePension,
          forecastDefinedBenefitFinalSalaryPension: app.forecastDefinedBenefitFinalSalaryPension,
          forecastCurrentDrawdownPensionFund: app.currentDrawdownPensionFundValue,
        },
        totalCreditCardBalances: app.creditCardBalance ?? 0,
        regularMonthlyCommitments: app.regularMonthlyCommitments ?? 0,
        annualCouncilTaxPayment: app.councilTax ?? 0,
      };
    }),
    jointCommitments: {
      totalCreditCardBalances: model.applicants.jointCommitments?.creditCardBalance ?? 0,
      regularMonthlyCommitments: model.applicants.jointCommitments?.regularMonthlyCommitments ?? 0,
      annualCouncilTaxPayment:  model.applicants.jointCommitments?.councilTax ?? 0,
    },
    affordabilityResult: results.affordability_result === 'Pass',
    maxAffordabilityLoanAmount: results.maximum_affordable_loan_amount,
    submissionDate: format(new Date(), 'yyyy/MM/dd HH:mm', { timeZone: 'Europe/London' }),
  };
}

export function mapEmploymentStatus(employmentStatus) {
  switch (employmentStatus) {
    case EmploymentStatus.Employed:
      return 'Employed/Fixed term contract';
    case EmploymentStatus.SelfEmployed:
      return 'Self employed (sole trader/partner)';
    case EmploymentStatus.DirectorOrShareholder:
      return 'Director/Shareholder with 20% or more share';
    case EmploymentStatus.Homemaker:
      return 'Homemaker';
    case EmploymentStatus.Retired:
      return 'Retired';
    case EmploymentStatus.Student:
      return 'Student';
    case EmploymentStatus.Unemployed:
      return 'Unemployed';
    default:
      return '';
  }
}

export function mapPropertyType(propertyType: PropertyType) {
  switch (propertyType) {
    case PropertyType.House:
      return 'House';
    case PropertyType.Flat:
      return 'Flat/Maisonette';
    default:
      return '';
  }
}
